import { render, staticRenderFns } from "./CreateRAMPPopup.vue?vue&type=template&id=c6a11f4c&scoped=true"
import script from "./CreateRAMPPopup.vue?vue&type=script&lang=js"
export * from "./CreateRAMPPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a11f4c",
  null
  
)

export default component.exports